'use strict';
var pressrelease = {
	init: function() {
		$(function() {
			$('.press-rel-filter-wrap select option[value="'+window.location.href+'"]').attr("selected","selected");
		});
	}
};
export default pressrelease;
